import { DeploymentStatus } from 'constant/Constants';
import { Syntax } from '@trlogic/ui-pack';
import { AccessBase } from '../../access/BaseAccess';
import { ResolutionJsonModel, RuleTypes } from './RuleDomains';

export interface RuleSchema {
  id?: string;
  name: string;
  priority: number;
  status: DeploymentStatus;
  actions: Array<string>;
}

export interface RuleJsonModel extends AccessBase {
  id?: string;
  name: string;
  createdDate: number | undefined;
  priority: number;
  score?: number | null;
  description: string | undefined;
  status: DeploymentStatus | undefined;
  rule: Syntax;
  resolutions: Array<ResolutionJsonModel>;
  workflow: Syntax;
  stage: DeploymentStatus;
  type: RuleTypes.MONITORING | RuleTypes.RESOLUTION;
  riskType: 'fraud' | 'compliance';
}

export enum CaseReason {
  FRAUD = 'DECLINED',
  SUSPICIOUS = 'WAITING_FOR_REVIEW',
  NOT_FRAUD = 'APPROVED',
}

export enum EscalatedReason {
  ESCALATED = 'ESCALATED',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  DEFAULT = 'DEFAULT',
}

export enum NodeType {
  EVENT = 'EVENT',
  CONDITION = 'CONDITION',
  ACTION = 'ACTION',
  FRAUD = 'FRAUD',
  NOT_FRAUD = 'NOT_FRAUD',
  TRANSACTION = 'TRANSACTION',
  PRIORITY = 'PRIORITY',
}

export enum ResolutionCaseType {
  CASE_TRUE = 'caseTrue',
  CASE_FALSE = 'caseFalse',
}
